/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/salesforce" */ '@atlassian/logo-third-party/salesforce'
		).then((m) => m.SalesforceIcon),
	{ moduleId: '@atlassian/logo-third-party/salesforce' },
);

const LazyForgeUnitoSalesforceDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-dev" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/icon' },
);

const LazyForgeUnitoSalesforceDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoSalesforceDevIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoSalesforceDevIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgeUnitoSalesforceDevSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoSalesforceDevSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
